import { render, staticRenderFns } from "./StudentInvoiceDetailDialog.vue?vue&type=template&id=262edcb5&scoped=true"
import script from "./StudentInvoiceDetailDialog.vue?vue&type=script&lang=js"
export * from "./StudentInvoiceDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentInvoiceDetailDialog.vue?vue&type=style&index=0&id=262edcb5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262edcb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('262edcb5')) {
      api.createRecord('262edcb5', component.options)
    } else {
      api.reload('262edcb5', component.options)
    }
    module.hot.accept("./StudentInvoiceDetailDialog.vue?vue&type=template&id=262edcb5&scoped=true", function () {
      api.rerender('262edcb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/StudentInvoiceDetailDialog.vue"
export default component.exports